var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pauseRestoreBtn",class:{
    'footer-container-tab': _vm.isFromTab || _vm.smallStyle,
    'footer-container-small': _vm.smallStyle,
    'footer-android-big': _vm.isAndroid && !_vm.isFromTab && !_vm.smallStyle,
  }},[_c('div',{staticClass:"btn-container"},[_c('rich-button',{on:{"click":_vm.handlePauseRestore}},[_vm._v(" "+_vm._s(_vm.$t('FoodC_pause_qsCr_nszu'))+" ")])],1),(_vm.requestLoading)?_c('LoadingMask'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }